import React from "react";
import { Modal }    from "react-bootstrap";
import CloseBtn     from "assets/icons/Close-1.svg";
import SavedImg     from "assets/images/wallet_account.png";
import "./Withdraw.scss";

const AccountSavedModal = ({ show, onClose }) => {
  return (
    <Modal className="account-saved-modal" size="lg" show={ show } onHide={ onClose } backdrop="static" centered>
      <Modal.Header className="p-0">
        <button type="button" className="close close-button position-relative pb-0" onClick={ onClose }>
          <img src={ CloseBtn } alt="modal-close" className="w-30" />
        </button>
      </Modal.Header>

      <Modal.Body>
        <div className="saved-title">Account saved successfully!</div>
        <div className="saved-text">Your bank account has been successfully added and is ready for withdrawals.</div>
        <img src={ SavedImg } alt="account-saved" className="saved-illustration" />
      </Modal.Body>

      <Modal.Footer className="d-block">
        <button type="button" className="btn btn-coral" onClick={ onClose }>Okay</button>
      </Modal.Footer>
    </Modal>
  );
};

export default AccountSavedModal;
